/**
 * WordPress dependencies
 */
export * from '@wordpress/icons';
export type { IconProps } from '@wordpress/icons/build-types/icon';
